import { useNavigate } from 'react-router-dom';
import { useLocalStorage, useToggle } from 'react-use';
import { Menu, Tooltip } from 'antd';

import 'Styles/SideNavigation.scss';
import yviLogo from '../../Assets/logo.png';
import toggle from '../../Assets/toggle.png';
import { FULL_MENU_LIST } from 'Utilities/constants';
import { usePersistedStore } from 'Store/persistedStore';
import useDeviceDetect from '../../Hooks/useDeviceDetect';
import { useAuthentication } from 'ServiceHooks/authHooks';
import Button from 'Components/CommonComponents/Button/Button';
import darkToggle from '../../Assets/toggleDark.svg';
import { useLayoutStore } from 'Store/LayoutStore';
import RadioGroup from 'Components/CommonComponents/ReactHooKForm/RadioGroup/RadioGroup';
import { useForm } from 'react-hook-form';
import nammudhajLogi from '../../Assets/namudhaj-logo.svg';
const MAX_LABEL_LENGTH = 15; // adjust as needed

const getItem = ({ menuName, menuKey, menuIcon, subMenu, menuType }) => {
  const shouldShowTooltip = menuName.length > MAX_LABEL_LENGTH;

  const labelContent = <span className="menu-label">{menuName}</span>;

  return {
    key: menuKey,
    type: menuType,
    icon: menuIcon,
    label: shouldShowTooltip ? (
      <Tooltip title={menuName} placement="right">
        {labelContent}
      </Tooltip>
    ) : (
      labelContent
    ),
    children: subMenu ? subMenu.map(getItem) : null,
  };
};

const AVAILABILITY_TYPES = [
  {
    label: 'Dark mode',
    value: 'true',
  },
  {
    label: 'Light Mode',
    value: 'false',
  },
];
const SideNavigation = (props) => {
  // const {
  //   clearErrors,
  //   register,
  //   handleSubmit,
  //   setValue,
  //   getValues,
  //   control,
  //   setError,
  //   reset,
  //   watch,
  //   formState: { errors },
  // } = useForm({
  //   mode: 'all',
  //   defaultValues: {
  //     modes: true,
  //   },
  // });
  const [userSettings] = useLocalStorage('user');
  const APP_LOGO = userSettings?.company_logo
    ? userSettings?.company_logo
    : yviLogo;
  const MAIN_LOGO = userSettings?.main_logo ? userSettings?.main_logo : '';
  console.log('userSettings', userSettings);

  const navigate = useNavigate();
  const { menuItems, adminMenuItems, userDetails, firstPermittedTab } =
    useAuthentication();
  const [collapsed, toggleCollapsed] = useToggle(false);
  const isMobileDevice = useDeviceDetect();
  const { isDarkMode, setDarkMode } = useLayoutStore();
  const { resetCurrentInterviewerTab } = usePersistedStore();

  const isSuperUser = userDetails?.is_superadmin === true;

  const currentMenuItems = isSuperUser ? adminMenuItems : menuItems;

  const items = currentMenuItems.map(getItem);

  console.log('collapsed', collapsed);

  return (
    <>
      {!isMobileDevice && (
        <div className="flex relative main-sidebar">
          <div
            className={` ${collapsed ? 'w-64 ' : 'w-16 p-3 '} 
            dark:bg-[#1A1D21] bg-secondaryBgMain h-screen relative transition-all duration-300 hidden sm:block overflow-y-auto scrollbar-hide`}
          >
            <div className="flex flex-col items-center justify-center dark:bg-[#1A1D21] bg-secondaryBgMain  ">
              <button
                type={'text'}
                className={`flex items-center justify-center space-x-3  ${collapsed ? 'mt-8' : ''} m-4`}
                onClick={() => navigate(firstPermittedTab)}
              >
                {collapsed === true ? (
                  <img src={MAIN_LOGO} alt="yvi-logo" className="w-24" />
                ) : (
                  <img src={APP_LOGO} alt="yvi-logo" className="w-30" />
                )}

                {/* {collapsed && process.env.REACT_APP_LOGO_STATIC_NAME && (
                  <span className="text-[#848484] text-xl font-bold">
                    {process.env.REACT_APP_LOGO_STATIC_NAME}
                  </span>
                )} */}
              </button>

              <Menu
                items={items}
                mode="inline"
                style={{ borderRight: 'none' }}
                className="dark:bg-[#1A1D21] bg-secondaryBgMain"
                defaultSelectedKeys={['1']}
                inlineCollapsed={!collapsed}
                onClick={({ key }) => {
                  if (key === FULL_MENU_LIST.interviews.menuKey) {
                    resetCurrentInterviewerTab();
                  }
                  let link;
                  if (key === 'logo') {
                    link = firstPermittedTab;
                  } else if (key.includes('.')) {
                    const keyPath = key.split('.');
                    const keyLength = keyPath.length;
                    const [menu, subMenu] = keyPath;
                    const chosenMenu = currentMenuItems.find(
                      (item) => item.menuName === menu,
                    );
                    const chosenSubMenu = chosenMenu.subMenu.find(
                      (item) => item.menuName === subMenu,
                    );
                    link = chosenSubMenu.menuLink;
                    if (keyLength > 2) {
                      const innerMenu = keyPath[2];
                      link = chosenSubMenu.subMenu.find(
                        (item) => item.menuName === innerMenu,
                      ).menuLink;
                    }
                  } else {
                    const chosenMenu = currentMenuItems.find(
                      (item) => item.menuName === key,
                    );
                    link = chosenMenu.menuLink;
                  }
                  navigate(link);
                }}
              />
              {/* <div>
                <RadioGroup
                  options={AVAILABILITY_TYPES}
                  control={control}
                  name={'modes'}
                  label={<p>Availability</p>}
                  onChange={(e, onChange) => {
                    onChange(e);
                    setDarkMode(e.value);
                    console.log('Selected Value:', e);
                  }}
                />
              </div> */}
            </div>
          </div>
          <div className={'duration-300 bg-white'}>
            <img
              src={isDarkMode ? darkToggle : toggle}
              alt="sidenav-toggle"
              onClick={() => toggleCollapsed()}
              className={`absolute cursor-pointer top-16 -right-3 w-6 ${!collapsed && 'rotate-180'} z-10 dark:border-dark-primaryMain border-[1px] rounded-full`}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SideNavigation;
